export default __webpack_public_path__ + "static/media/C_05_01_bg.cee58776.mp4";